 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"beacon~beacon_carried~card~card_gateway~category~floor~geofence~link~sanid~timeline~user":"beacon~beacon_carried~card~card_gateway~category~floor~geofence~link~sanid~timeline~user","beacon_carried~card~category~link":"beacon_carried~card~category~link","beacon_carried":"beacon_carried","card~link":"card~link","card":"card","category":"category","link~user":"link~user","link":"link","beacon~card_gateway":"beacon~card_gateway","beacon":"beacon","card_gateway":"card_gateway","floor~geofence":"floor~geofence","floor":"floor","geofence":"geofence","user":"user","sanid":"sanid","timeline":"timeline","indoor~outdoor":"indoor~outdoor","indoor":"indoor","outdoor":"outdoor","user_search":"user_search","geofence-monitor":"geofence-monitor","login":"login","notification~stamp_rally~workrecorder":"notification~stamp_rally~workrecorder","notification":"notification","stamp_rally":"stamp_rally","workrecorder":"workrecorder","setting":"setting"}[chunkId]||chunkId) + "." + {"beacon~beacon_carried~card~card_gateway~category~floor~geofence~link~sanid~timeline~user":"a16ac30c","beacon_carried~card~category~link":"a46c0a40","beacon_carried":"69f1f28b","card~link":"c9bec5c2","card":"8d3c10ab","category":"499684f3","link~user":"cd8253ed","link":"698bd7b3","beacon~card_gateway":"5acd8b2d","beacon":"863aa59c","card_gateway":"3ccfcd64","floor~geofence":"495309c9","floor":"1dd18e83","geofence":"6ff92062","user":"020c22f8","sanid":"edaaca42","timeline":"f1421b6c","chunk-3d7bcdf9":"8a5aedae","chunk-28569fa7":"2124cbd5","chunk-0fdc0cd2":"764fef60","indoor~outdoor":"957a242a","indoor":"74a3b8b9","chunk-dda6d02e":"df6252b6","chunk-e790a840":"e04018d9","outdoor":"b383a0a1","user_search":"84285a3c","geofence-monitor":"d3134d84","login":"cb953c57","notification~stamp_rally~workrecorder":"54560cbc","notification":"b14a238b","stamp_rally":"5fc6b4ca","workrecorder":"f4cf71b4","setting":"1d60f749"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"beacon_carried~card~category~link":1,"link~user":1,"link":1,"beacon~card_gateway":1,"beacon":1,"card_gateway":1,"floor~geofence":1,"floor":1,"geofence":1,"user":1,"sanid":1,"timeline":1,"chunk-3d7bcdf9":1,"chunk-0fdc0cd2":1,"indoor~outdoor":1,"indoor":1,"chunk-e790a840":1,"login":1,"notification~stamp_rally~workrecorder":1,"notification":1,"stamp_rally":1,"workrecorder":1,"setting":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"beacon~beacon_carried~card~card_gateway~category~floor~geofence~link~sanid~timeline~user":"beacon~beacon_carried~card~card_gateway~category~floor~geofence~link~sanid~timeline~user","beacon_carried~card~category~link":"beacon_carried~card~category~link","beacon_carried":"beacon_carried","card~link":"card~link","card":"card","category":"category","link~user":"link~user","link":"link","beacon~card_gateway":"beacon~card_gateway","beacon":"beacon","card_gateway":"card_gateway","floor~geofence":"floor~geofence","floor":"floor","geofence":"geofence","user":"user","sanid":"sanid","timeline":"timeline","indoor~outdoor":"indoor~outdoor","indoor":"indoor","outdoor":"outdoor","user_search":"user_search","geofence-monitor":"geofence-monitor","login":"login","notification~stamp_rally~workrecorder":"notification~stamp_rally~workrecorder","notification":"notification","stamp_rally":"stamp_rally","workrecorder":"workrecorder","setting":"setting"}[chunkId]||chunkId) + "." + {"beacon~beacon_carried~card~card_gateway~category~floor~geofence~link~sanid~timeline~user":"31d6cfe0","beacon_carried~card~category~link":"e6bfc4c6","beacon_carried":"31d6cfe0","card~link":"31d6cfe0","card":"31d6cfe0","category":"31d6cfe0","link~user":"8a3bad56","link":"fce76079","beacon~card_gateway":"433e4eb2","beacon":"8ce56ba7","card_gateway":"81ce3fe4","floor~geofence":"e6bfc4c6","floor":"64fcc751","geofence":"2d09ccd4","user":"e6bfc4c6","sanid":"e6bfc4c6","timeline":"3ad7502d","chunk-3d7bcdf9":"e6bfc4c6","chunk-28569fa7":"31d6cfe0","chunk-0fdc0cd2":"60e5a0e1","indoor~outdoor":"cb8a7204","indoor":"4389539a","chunk-dda6d02e":"31d6cfe0","chunk-e790a840":"cf489d9f","outdoor":"31d6cfe0","user_search":"31d6cfe0","geofence-monitor":"31d6cfe0","login":"4ba6c896","notification~stamp_rally~workrecorder":"e6bfc4c6","notification":"26bce617","stamp_rally":"7a70dcd1","workrecorder":"bfb017dd","setting":"63ed6ff9"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
